var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 567,
    height: 721,
    viewBox: "0 0 567 721",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 516,
    cy: 205,
    r: 516,
    fill: "#5956E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse28);
export default __webpack_public_path__ + "static/media/Ellipse 28.76f12d7eccb44af65113341abe66c6d3.svg";
export { ForwardRef as ReactComponent };